import React, { useState, useContext, useEffect } from 'react';
import { TextField, Button, Paper, Typography, MenuItem, InputLabel, Grid, FormControl, Select, Box, IconButton, Stack } from '@mui/material';
import { isEmpty } from 'lodash';
import SaveRoundedIcon from '@mui/icons-material/SaveRounded';
import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded';
import PersonRoundedIcon from '@mui/icons-material/PersonRounded';
import LocationOnRoundedIcon from '@mui/icons-material/LocationOnRounded';
import WorkRoundedIcon from '@mui/icons-material/WorkRounded';
import PhotoCameraRoundedIcon from '@mui/icons-material/PhotoCameraRounded';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';

import { getToken } from '../../api/Account';
import { DataContext } from '../../context/DataContext';
import { getCommunitiesByMunAsync, getMunicipalitiesByDeptopAsync, getOnlyDepartmentListAsync } from '../../api/Locations';
import { getRuta, simpleMessage, validateCedula } from '../../helpers/Helpers';
import { addClientAsync } from '../../api/Clients';
import { useNavigate } from 'react-router-dom';
import { getSucursalByUserAsync } from '../../api/Users';

const CardHeader = ({ icon, title }) => (
	<Stack direction="row" spacing={1} alignItems="center" sx={{ marginBottom: '16px' }}>
		<Box sx={{ display: 'flex', color: 'success.main', fontSize: 19 }}>{icon}</Box>
		<Typography sx={{ fontSize: 14, fontWeight: 600 }}>{title}</Typography>
	</Stack>
);

const AddClient = () => {
	const token = getToken();
	let ruta = getRuta();
	let navigate = useNavigate();

	const { setIsLoading, setIsUnautorized } = useContext(DataContext);

	const [departmentList, setDepartmentList] = useState([]);
	const [selectedDepartment, setselectedDepartment] = useState('');

	const [MunicipalitiesList, setMunicipalitiesList] = useState([]);
	const [selectedMunicipality, setselectedMunicipality] = useState('');

	const [communitiesList, setCommunitiesList] = useState([]);
	const [selectedCommunity, setselectedCommunity] = useState('');

	const [firstName, setFirstName] = useState('');
	const [secondName, setSecondName] = useState('');
	const [lastName, setLastName] = useState('');
	const [secondLastName, setSecondLastName] = useState('');
	const [identification, setIdentification] = useState('');
	const [phone, setPhone] = useState('');

	const [sex, setSex] = useState('');
	const [civilStatus, setCivilStatus] = useState('');

	const [address, setAddress] = useState('');

	const [company, setCompany] = useState('');
	const [companyAddress, setCompanyAddress] = useState('');

	const [actividadEconomica, setActividadEconomica] = useState('');

	const [sucursalList, setSucursalList] = useState([]);
	const [selectedSucursal, setSelectedSucursal] = useState('');

	const [selectedFiles, setSelectedFiles] = useState([]);
	const [previews, setPreviews] = useState([]);

	useEffect(() => {
		(async () => {
			setIsLoading(true);
			const result = await getOnlyDepartmentListAsync(token);
			if (!result.statusResponse) {
				setIsLoading(false);
				if (result.error === 'Unauthorized') {
					setIsUnautorized(true);
					return;
				}
				simpleMessage(result.error, 'error');
				return;
			}

			setDepartmentList(result.data.result);
			setIsLoading(false);
		})();
		getSucursals(token);
	}, []);

	const validate = () => {
		let isValid = true;
		if (firstName.length === 0) {
			simpleMessage('Debe ingresar un nombre', 'error');
			return (isValid = false);
		}

		if (identification.length === 0) {
			simpleMessage('Debe ingresar una cédula', 'error');
			return (isValid = false);
		}

		if (!validateCedula(identification)) {
			simpleMessage('Debe ingresar una cédula valida', 'error');
			return (isValid = false);
		}

		if (phone.length === 0) {
			simpleMessage('Debe ingresar un teléfono', 'error');
			return (isValid = false);
		}

		if (sex === '') {
			simpleMessage('Debe seleccionar un sexo', 'error');
			return (isValid = false);
		}

		if (civilStatus === '') {
			simpleMessage('Debe seleccionar un estado civil', 'error');
			return (isValid = false);
		}

		if (selectedCommunity === '') {
			simpleMessage('Debe seleccionar una comunidad', 'error');
			return (isValid = false);
		}

		if (address.length === 0) {
			simpleMessage('Debe ingresar una dirección', 'error');
			return (isValid = false);
		}

		if (isEmpty(actividadEconomica)) {
			simpleMessage('Debe ingresar una actividad económica', 'error');
			return (isValid = false);
		}

		if (selectedFiles.length < 2) {
			simpleMessage('Debe seleccionar al menos dos fotos', 'error');
			return (isValid = false);
		}
		return isValid;
	};

	const addNewClient = async () => {
		if (validate()) {
			const formData = new FormData();
			formData.append('firstName', firstName);
			formData.append('secondName', secondName);
			formData.append('lastName', lastName);
			formData.append('secondLastName', secondLastName);
			formData.append('identification', identification);
			formData.append('phone', phone);
			formData.append('sex', sex === 0 ? 'MASCULINO' : 'FEMENINO');
			formData.append(
				'civilStatus',
				civilStatus === 0 ? (sex === 0 ? 'SOLTERO' : 'SOLTERA') : civilStatus === 1 ? (sex === 0 ? 'CASADO' : 'CASADA') : 'UNION LIBRE'
			);
			formData.append('idCommunity', selectedCommunity);
			formData.append('address', address);
			formData.append('company', company);
			formData.append('companyAddress', companyAddress);
			formData.append('actividadEconomica', actividadEconomica);
			formData.append('sucursalId', selectedSucursal);

			selectedFiles.forEach((photo) => {
				formData.append(`clientPhotos`, photo);
			});

			setIsLoading(true);
			const result = await addClientAsync(token, formData);
			if (!result.statusResponse) {
				setIsLoading(false);
				if (result.error === 'Unauthorized') {
					setIsUnautorized(true);
					return;
				}

				simpleMessage(result.error, 'error');
				return;
			}

			setIsLoading(false);
			clearData();
			simpleMessage('Cliente Agregado...!', 'success');
		}
	};

	const handleChangeSex = (event) => {
		setSex(event.target.value);
	};

	const handleChangeCivilStatus = (event) => {
		setCivilStatus(event.target.value);
	};

	const handleChangeDepartment = async (event) => {
		setMunicipalitiesList([]);
		setCommunitiesList([]);
		setselectedDepartment(event.target.value);

		if (event.target.value !== '') {
			setIsLoading(true);
			const result = await getMunicipalitiesByDeptopAsync(token, event.target.value);
			if (!result.statusResponse) {
				setIsLoading(false);
				if (result.error === 'Unauthorized') {
					setIsUnautorized(true);
					return;
				}
				simpleMessage(result.error, 'error');
				return;
			}
			setMunicipalitiesList(result.data.result);
			setIsLoading(false);
		} else {
			setMunicipalitiesList([]);
		}
	};

	const handleChangeMunicipality = async (event) => {
		setCommunitiesList([]);
		setselectedMunicipality(event.target.value);

		if (event.target.value !== '') {
			setIsLoading(true);
			const result = await getCommunitiesByMunAsync(token, event.target.value);
			if (!result.statusResponse) {
				setIsLoading(false);
				if (result.error === 'Unauthorized') {
					setIsUnautorized(true);
					return;
				}
				simpleMessage(result.error, 'error');
				return;
			}
			setCommunitiesList(result.data.result);
			setIsLoading(false);
		} else {
			setCommunitiesList([]);
		}
	};

	const handleChangeComunity = (event) => {
		setselectedCommunity(event.target.value);
	};

	const clearData = () => {
		setFirstName('');
		setSecondName('');
		setLastName('');
		setSecondLastName('');
		setPhone('');
		setIdentification('');
		setSex('');
		setCivilStatus('');
		setselectedDepartment('');
		setselectedMunicipality('');
		setselectedCommunity('');
		setAddress('');
		setActividadEconomica('');
		setCompany('');
		setCompanyAddress('');
		setSelectedFiles([]);
		setPreviews([]);
	};

	const getSucursals = async () => {
		setIsLoading(true);
		const result = await getSucursalByUserAsync(token);
		if (!result.statusResponse) {
			setIsLoading(false);
			if (result.error === 'Unauthorized') {
				setIsUnautorized(true);
				return;
			}
			simpleMessage(result.error, 'error');
			return;
		}
		setIsLoading(false);
		setSucursalList(result.data.result);
		setSelectedSucursal(result.data.result[0].id);
	};

	const onChangeFile = (e) => {
		const files = Array.from(e.target.files);

		if (!files) return;

		if (files.length > 2) {
			simpleMessage('Solo puedes seleccionar máximo 2 archivos', 'error');
			e.target.value = '';
			return;
		}

		const newPreviews = files.map((file) => ({
			file,
			preview: URL.createObjectURL(file)
		}));

		setSelectedFiles(files);
		setPreviews(newPreviews);
	};

	const removeImage = (index) => {
		URL.revokeObjectURL(previews[index].preview);

		const newPreviews = previews.filter((_, i) => i !== index);
		const newFiles = selectedFiles.filter((_, i) => i !== index);

		setPreviews(newPreviews);
		setSelectedFiles(newFiles);
	};

	React.useEffect(() => {
		return () => {
			previews.forEach((preview) => URL.revokeObjectURL(preview.preview));
		};
	}, []);

	return (
		<div>
			<Box
				onClick={() => navigate(`${ruta}/clients`)}
				sx={{
					display: 'inline-flex',
					alignItems: 'center',
					gap: '6px',
					color: 'text.disabled',
					fontSize: 13,
					fontWeight: 500,
					marginBottom: '16px',
					cursor: 'pointer',
					'&:hover': { color: '#00a152' }
				}}
			>
				<ArrowBackRoundedIcon sx={{ fontSize: 19 }} />
				Volver a clientes
			</Box>

			<Stack spacing={1.75}>
				<Paper sx={{ padding: '20px 22px' }}>
					<CardHeader icon={<PersonRoundedIcon fontSize="inherit" />} title="Datos del cliente" />
					<Grid container spacing={2}>
						<Grid item xs={12} sm={6}>
							<Stack spacing={2}>
								<TextField required fullWidth onChange={(e) => setFirstName(e.target.value.toUpperCase())} value={firstName} label={'Primer Nombre'} />
								<TextField fullWidth onChange={(e) => setSecondName(e.target.value.toUpperCase())} value={secondName} label={'Segundo Nombre'} />
								<TextField required fullWidth onChange={(e) => setLastName(e.target.value.toUpperCase())} value={lastName} label={'Primer apellido'} />
								<TextField fullWidth onChange={(e) => setSecondLastName(e.target.value.toUpperCase())} value={secondLastName} label={'Segundo Apellido'} />
							</Stack>
						</Grid>

						<Grid item xs={12} sm={6}>
							<Stack spacing={2}>
								<TextField fullWidth required onChange={(e) => setPhone(e.target.value.toUpperCase())} value={phone} label={'Telefono'} />
								<TextField required fullWidth onChange={(e) => setIdentification(e.target.value.toUpperCase())} value={identification} label={'Cedula: 000-000000-0000X'} />
								<FormControl fullWidth style={{ textAlign: 'left' }}>
									<InputLabel id="demo-simple-select-standard-label">Sexo</InputLabel>
									<Select labelId="demo-simple-select-standard-label" onChange={handleChangeSex} value={sex} label="Municipio">
										<MenuItem value={0}>MASCULINO</MenuItem>
										<MenuItem value={1}>FEMENINO</MenuItem>
									</Select>
								</FormControl>

								<FormControl fullWidth style={{ textAlign: 'left' }}>
									<InputLabel id="demo-simple-select-standard-label">Estado Civil</InputLabel>
									<Select labelId="demo-simple-select-standard-label" onChange={handleChangeCivilStatus} value={civilStatus} label="Estado Civil">
										<MenuItem value={0}>{sex === 0 ? 'SOLTERO' : 'SOLTERA'}</MenuItem>
										<MenuItem value={1}>{sex === 0 ? 'CASADO' : 'CASADA'}</MenuItem>
										<MenuItem value={2}>UNION LIBRE</MenuItem>
									</Select>
								</FormControl>
							</Stack>
						</Grid>
					</Grid>
				</Paper>

				<Paper sx={{ padding: '20px 22px' }}>
					<CardHeader icon={<LocationOnRoundedIcon fontSize="inherit" />} title="Ubicación del cliente" />
					<Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="space-between" spacing={2}>
						<FormControl fullWidth required>
							<InputLabel id="demo-simple-select-standard-label">Departamento</InputLabel>
							<Select labelId="demo-simple-select-standard-label" value={selectedDepartment} onChange={handleChangeDepartment} label="Departamento" style={{ textAlign: 'left' }}>
								<MenuItem value="">
									<em>Seleccione un Departamento</em>
								</MenuItem>
								{departmentList.map((item) => (
									<MenuItem key={item.id} value={item.id}>
										{item.name}
									</MenuItem>
								))}
							</Select>
						</FormControl>

						<FormControl fullWidth required>
							<InputLabel id="demo-simple-select-standard-label">Municipio</InputLabel>
							<Select labelId="demo-simple-select-standard-label" value={selectedMunicipality} onChange={handleChangeMunicipality} label="Municipio" style={{ textAlign: 'left' }}>
								<MenuItem value="">
									<em>Seleccione un Municipio</em>
								</MenuItem>
								{MunicipalitiesList.map((item) => (
									<MenuItem key={item.id} value={item.id}>
										{item.name}
									</MenuItem>
								))}
							</Select>
						</FormControl>

						<FormControl fullWidth required>
							<InputLabel id="demo-simple-select-standard-label">Comunidad</InputLabel>
							<Select labelId="demo-simple-select-standard-label" value={selectedCommunity} onChange={handleChangeComunity} label="Comunidad" style={{ textAlign: 'left' }}>
								<MenuItem value="">
									<em>Seleccione una Comunidad</em>
								</MenuItem>
								{communitiesList.map((item) => (
									<MenuItem key={item.id} value={item.id}>
										{item.name}
									</MenuItem>
								))}
							</Select>
						</FormControl>
					</Stack>

					<TextField required fullWidth multiline onChange={(e) => setAddress(e.target.value.toUpperCase())} sx={{ marginTop: '16px' }} value={address} label={'Direccion'} />
				</Paper>

				<Paper sx={{ padding: '20px 22px' }}>
					<CardHeader icon={<WorkRoundedIcon fontSize="inherit" />} title="Actividad económica" />
					<Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="space-between" spacing={2}>
						<TextField required fullWidth onChange={(e) => setActividadEconomica(e.target.value.toUpperCase())} value={actividadEconomica} label={'Actividad Economica'} />
						<TextField required fullWidth onChange={(e) => setCompany(e.target.value.toUpperCase())} value={company} label={'Negocio o Centro de trabajo'} />
					</Stack>

					<Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="space-between" spacing={2} sx={{ marginTop: '16px' }}>
						<TextField required fullWidth multiline onChange={(e) => setCompanyAddress(e.target.value.toUpperCase())} value={companyAddress} label={'Direccion del trabajo'} />

						<FormControl fullWidth style={{ textAlign: 'left' }}>
							<InputLabel id="demo-simple-select-standard-label">Sucursal</InputLabel>
							<Select labelId="demo-simple-select-standard-label" onChange={(e) => setSelectedSucursal(e.target.value)} value={selectedSucursal} label="Sucursal">
								{sucursalList.map((item) => (
									<MenuItem key={item.id} value={item.id}>
										{item.description}
									</MenuItem>
								))}
							</Select>
						</FormControl>
					</Stack>
				</Paper>

				<Paper sx={{ padding: '20px 22px' }}>
					<CardHeader icon={<PhotoCameraRoundedIcon fontSize="inherit" />} title="Fotos del cliente (mínimo 2)" />
					<TextField
						fullWidth
						type="file"
						label="Fotos del Cliente"
						inputProps={{
							multiple: true,
							accept: 'image/*',
							shrink: true
						}}
						onChange={onChangeFile}
					/>

					{previews.length > 0 && (
						<Grid container spacing={1.5} sx={{ marginTop: '4px' }}>
							{previews.map((preview, index) => (
								<Grid item xs={6} sm={4} key={index}>
									<Box
										sx={{
											position: 'relative',
											borderRadius: '11px',
											border: '1px solid',
											borderColor: 'divider',
											height: 160,
											display: 'flex',
											alignItems: 'center',
											justifyContent: 'center',
											overflow: 'hidden',
											backgroundColor: 'background.default'
										}}
									>
										<IconButton
											size="small"
											sx={{
												position: 'absolute',
												top: 8,
												right: 8,
												backgroundColor: 'rgba(255,255,255,0.8)',
												'&:hover': { backgroundColor: 'rgba(255,255,255,0.9)' }
											}}
											onClick={() => removeImage(index)}
										>
											<CloseRoundedIcon sx={{ fontSize: 18 }} />
										</IconButton>

										<img
											src={preview.preview}
											alt={`Vista previa ${index + 1}`}
											style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }}
											onLoad={() => URL.revokeObjectURL(preview.preview)}
										/>
									</Box>
									<Typography variant="caption" display="block" textAlign="center" sx={{ mt: 1 }}>
										{preview.file.name}
									</Typography>
								</Grid>
							))}
						</Grid>
					)}
				</Paper>

				<Button variant="contained" color="primary" startIcon={<SaveRoundedIcon />} fullWidth onClick={() => addNewClient()} sx={{ padding: '12px' }}>
					Agregar cliente
				</Button>
			</Stack>
		</div>
	);
};

export default AddClient;
